import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useMutation } from '@apollo/client'
import { Close, Delete } from '@mui/icons-material'
import { DELETE_DAYCARE_GROUP } from '@/modules/API/daycareGroup/daycareGroupHandler'
import styles from './deleteGroupDialog.module.scss'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ValidDeleteGroupProps {
    open: boolean
    handleClose: () => void
    groupId: number
    refetchGroups: () => void
}

const ValidDeleteDaycareGroupDialog: FunctionComponent<ValidDeleteGroupProps> = ({
    open,
    handleClose,
    groupId,
    refetchGroups
}: ValidDeleteGroupProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const navigate: NavigateFunction = useNavigate()

    const [deleteOneGroup] = useMutation(DELETE_DAYCARE_GROUP, {
        variables: {
            groupId: groupId
        },
        onCompleted: () => {
            showNotificationSuccess(t('groupPriorityDeleted'))

            refetchGroups()

            handleClose()

            navigate('/group')
        },
        onError: () => {
            showNotificationError(t('errorDeletedGroupPriority'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('confirmDeleteGroup')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmDeleteGroupMessage')}</p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteOneGroup}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ValidDeleteDaycareGroupDialog
